import {
    AssignedParticipantUnreadInfo,
    ConversationMemberView,
    ConversationParticipantView,
    ConversationView,
} from '@mark43/cad-api';
import { ConversationKey } from '../models';
import { alphabeticalMemberSort, buildParticipantKey } from '../store/helpers';
import { ParticipantIdentities } from '../store/types';

export const getShortLabel = (member?: ConversationMemberView): string => {
    if (!member) {
        return '';
    }
    return member.shortLabel ?? member.label;
};

export const participantToAssignedParticipant = (
    participantIdentity: ConversationParticipantView,
    bookmarkedMessagesCount: number
): AssignedParticipantUnreadInfo => {
    return {
        entityType: participantIdentity.entityType,
        hasStandardUnread: false,
        hasUrgentUnread: false,
        label: participantIdentity.label,
        unreadCount: 0,
        participantId: participantIdentity.id,
        bookmarkedMessagesCount,
    };
};

export const isParticipantIdentityAssignedToUser = (
    participant: ConversationParticipantView,
    participantIdentities?: ParticipantIdentities
) => {
    return (
        participantIdentities?.activeMappedByKey[
            buildParticipantKey(participant.id, participant.entityType)
        ] !== undefined
    );
};

export const filteredAndSortedMembers = (
    selectedConversation?: ConversationView,
    selectedConversationKey?: ConversationKey
): ConversationMemberView[] => {
    if (selectedConversation !== undefined && selectedConversationKey !== undefined) {
        const { members } = selectedConversation;
        const isConversationForSelf =
            members.length === 1 &&
            members[0].id === selectedConversationKey?.participantIdentity?.id;

        if (isConversationForSelf) {
            return members;
        }

        return members
            .filter(
                (member) =>
                    !!selectedConversationKey.participantIdentity &&
                    member.id !== selectedConversationKey.participantIdentity.id
            )
            .sort(alphabeticalMemberSort);
    }
    return [];
};
